import React from 'react';

import './index.scss';

//api
import {api} from '../../../functions/api';

//material-ui
import { CircularProgress, Grid, TextField,  Paper, MuiThemeProvider, createMuiTheme, InputLabel, FormControl, Select, MenuItem } from '@material-ui/core';

//custom components
import CustomButton from '../../../components/basic/CustomButton';
import DeleteDialog from '../../../components/global/deleteDialog';

//other libraries
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactQuill from 'react-quill';
// import {CopyToClipboard} from 'react-copy-to-clipboard';
import Icon from '@mdi/react'
import { mdiClose, mdiDelete } from '@mdi/js'
import Dropzone from 'react-dropzone'

const TIMEOUT = 3000;

const EXTENSIONS = [".pdf",".xls",".xlsx",".doc",".docx",".ppt",".pptx"]

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiInput: {
            underline: {
                "&::after": {
                    borderBottomColor: "#777777",
                    borderBottom: "2px solid #777777 !important"
                }
            },
        },
        MuiFormLabel: {
            root: {
                color:  "#777777 !important"
            },
            focused: {
                color:  "#777777 !important"
            }
        },
        MuiFormControl: {
            root: {
                marginLeft: "2px",
                marginRight: "5px",
                width: "100%",
            }
        },
        MuiSelect: {
            select: {
                minWidth: "auto",
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class StaticPageCreateEdit extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: true,
            message: "",
            openSnackbar: false,
            editorHtml: '',
            title: "",
            slug: "",
            loadingBtn: false,
            file: [],
            extension: null,
            is_for_shops: false,
            show_in_widget: false,
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.static_pages)
            && toJS(this.props.internal.user.data.permissions.static_pages.update)){

            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.HEADER.STATIC_PAGES)
            let idStaticPage = this.props.match.params.id
            if(idStaticPage) {
                this.setState({loading: true})
                this.loadStaticPage(idStaticPage)
            }
            else {
                this.setState({loading: false})
            }
        }
        else{
            this.props.internal.setRoute( this.props.history, this.props.location.pathname);
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    closeSnackBar() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({ message: "", openSnackbar: false })
        }, TIMEOUT)
    }

    loadStaticPage = async(inputId) => {
        
        let idStaticPage
        if(inputId) {
            idStaticPage = inputId;
        }
        else if(this.props.match.params.id) {
            idStaticPage = this.props.match.params.id;
        }

        let load_data = await api({
            method: 'get',
            url: `static-pages/${idStaticPage}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.props.internal.setDataForSimpeTable(load_data.data.data)
            this.setState({
                title: load_data.data.data.title !== null ? load_data.data.data.title : "",
                slug: load_data.data.data.slug !== null ? load_data.data.data.slug : "",
                editorHtml: load_data.data.data.content !== null ? load_data.data.data.content : "",
                is_for_shops: load_data.data.data.is_for_shops,
                show_in_widget: load_data.data.data.show_in_widget
            })
        }
        this.setState({loading: false});
    }

    modules = {
        toolbar: [
            ['bold', 'italic', 'underline'], // 'strike', 'blockquote'
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{'list': 'ordered'}, {'list': 'bullet'}], // {'indent': '-1'}, {'indent': '+1'}
            [{ "size": [ 'small', false, 'large', 'huge' ]}],
            [{"color": []}, {background: []}],
            [{"align": []}],
            ['link']
        ],
        clipboard: {
          // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        }
      }
      /*
       * Quill editor formats
       * See https://quilljs.com/docs/formats/
       */
    formats = [
        'bold', 'italic', 'underline',
        'header',
        'list', 'bullet',
        'size',
        'color',
        'background',
        'align',
        'link'
    ]

    handleChange (html) {
        this.setState({ editorHtml: html });
    }

    handleChangeTextField = name => event => {
        if(this.props.match.params.id) {
            this.setState({
                [name]: event.target.value,
                
            });
        }
        else {
            // let tmpSlug = event.target.value.toLowerCase()
            // tmpSlug = tmpSlug.replace(/[^A-Z0-9]/ig, "-")
            // this.setState({
            //     [name]: event.target.value,
            //     slug: tmpSlug
            // });
            this.setState({
                [name]: event.target.value,
                
            });
            this.handleSuggestAlias(event.target.value)
        }
    };

    goBack = () => {
        this.props.internal.pushRoute('/static_pages')
    }

    newOrEditStaticPage = async() => {
        let id = null;
        if(this.state.editorHtml !== "" && this.state.title !== "") {
            this.setState({loadingBtn: true})
            let method = "post"
            let url = "static-pages"
            let params = {
                title: this.state.title,
                content: this.state.editorHtml,
                is_for_shops: this.state.is_for_shops,
                show_in_widget: this.state.show_in_widget
            }
            if(this.props.match.params.id) {
                method = "patch";
                url += `/${this.props.match.params.id}`
                id = this.props.match.params.id
            }

            let create_data = await api({
                method: method,
                url: url,
                authorization: this.props.internal.user.access_token,
                params: params
            })

            if(create_data.success === true || (create_data.success === false && create_data.status === 201)) {
                this.props.internal.setSnackbar(create_data.data.message, true)

                this.props.internal.pushRoute(`/static_pages`)

                id = create_data.data.data.id
            }
            else{
                let resultError = "";
                if(create_data.data.data.errors) {
                    for(let error in create_data.data.data.errors){
                        resultError += create_data.data.data.errors[error] + " "
                    }
                }
                this.props.internal.setSnackbar(resultError, true)
            }
            
        }
        else {
            let resultError = "";
            if(this.state.title === "") {
                resultError += this.props.translate.i18n.GLOBAL.ALERTS.TITLE_REQUIRED + " ";
            }

            if(this.state.editorHtml === "") {
                resultError += this.props.translate.i18n.GLOBAL.ALERTS.CONTENT_REQUIRED;
            }
            this.props.internal.setSnackbar(resultError, true)

        }

        if(id !== null && this.state.file.length > 0) {
            for(let i in this.state.file) {
                this.uploadDoc(id, this.state.file[i])
            }
            
        }
        else if(id === null) {
            // this.props.internal.setSnackbar("najpr si vytvorte staticku stranku", true)
        }
        this.setState({loadingBtn: false})
    }

    uploadDoc = async(id, file) => {
        let upload_data = await api({
            url: `static-pages/${id}/upload`,
            method: 'POST',
            formData: true,
            //TODO: opravit api call, lebo ide cez for ciklus a pridava tam file 2x
            formDataDoc: true,
            authorization: this.props.internal.user.access_token,
            params: {
                file: file
            }
        })
    }

    handleDrop = (files) => {
        if(files !== null && files !== undefined && files.length > 0) {
            let fileNameArr = files[0].name.split('.');

            let extension = fileNameArr[fileNameArr.length - 1]
            if(EXTENSIONS.includes("."+extension)) {
                let files_from_state = this.state.file
                files_from_state.push(files[0])
                this.setState({
                    file: files_from_state,
                    extension: extension,
                })
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FORMAT_IS_NOT_VALID, true)
        }
        
    }

    timeout2 = null
    handleSuggestAlias = (slug) => {
        clearTimeout(this.timeout2)
        this.timeout2 = setTimeout(() => {
            this.aliasSuggestion(slug)
        }, 500)
    }

    aliasSuggestion = async (slug) => {
        let alias_suggestion = await api({
            method: 'POST',
            url: 'static-pages/suggest-slug',
            authorization: this.props.internal.user.access_token,
            params: {
                title: slug
            }
        })

        if(alias_suggestion.success === true) {
            this.setState({slug: alias_suggestion.data.data.slug})
        }
    }

    deleteDocId = null

    handleDeleteFile = (file, index) => {
        this.props.internal.setActionDelete()
        this.deleteDocId = file.id
    }

    deleteFile = async() => {
        let id = this.props.match.params.id
        let delete_data = await api({
            method: 'DELETE',
            url: `static-pages/${id}/remove/${this.deleteDocId}`,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.props.internal.setDataForSimpeTable(delete_data.data.data)
            this.props.internal.setActionDelete();
            // this.setState({
            //     title: load_data.data.data.title !== null ? load_data.data.data.title : "",
            //     slug: load_data.data.data.slug !== null ? load_data.data.data.slug : "",
            //     editorHtml: load_data.data.data.content !== null ? load_data.data.data.content : "",
            // })
        }
    }

    handleSetStaticPagesForShops = (event) => {
        this.setState({is_for_shops: event.target.value})
    }
    
    handleSetStaticPagesInWidget = (event) => {
        this.setState({show_in_widget: event.target.value})
    }

    handleDeleteFileFromState = (f, index) => {
        let tmpFiles = this.state.file

        delete tmpFiles[index]
        let newFiles = tmpFiles.filter(item => item !== "" || item !== undefined || item !== null)

        this.setState({file: newFiles})
    }
    

    render() {
        let files = toJS(this.props.internal.dataForSimpeTable.files)
        return (
            this.state.loading
                ?
                <CircularProgress className={'circular-progress'} />
                :
                <div className={'templates-container'}>
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.STATIC_PAGES.DELETE_DOC_FROM_STATIE_PAGE_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.deleteFile}
                    />
                    <div className={'flex header'}>
                        <h1 className={'title'}>{this.props.match.params.id ? this.props.translate.i18n.MODULES.STATIC_PAGES.EDIT_STATIC_PAGE_TITLE : this.props.translate.i18n.MODULES.STATIC_PAGES.NEW_STATIC_PAGE_TITLE}</h1>
                        <div className={'back-btn'} onClick={this.goBack}>
                            <Icon path={mdiClose} size={1}/>
                        </div>
                    </div>
                    <MuiThemeProvider theme={theme}>
                        <Grid container spacing={16} style={{marginTop: "16px", overflow: 'auto', height: "calc(100vh - 200px)"}}>
                            <Grid item xs={12} sm={6} md={5}>
                                <Grid container spacing={16} >
                                    <Grid item xs={12}>
                                        <Paper style={{padding: "20px"}}>
                                            <TextField
                                                className={''} //template-item
                                                id="title"
                                                label={this.props.translate.i18n.MODULES.STATIC_PAGES.TITLE}
                                                value={this.state.title}
                                                onChange={this.handleChangeTextField('title')}
                                                fullWidth
                                            />
                                            <div className={'slug disabled'}>
                                                <span>{this.props.translate.i18n.MODULES.STATIC_PAGES.SLUG}</span>
                                                <p>{this.state.slug}</p>
                                            </div>
                                            <FormControl className="select-type-position" style={{marginTop: "5px"}}>
                                                <InputLabel
                                                    htmlFor="select-shop"
                                                    className={"label-select-type"}
                                                    // shrink={true}
                                                >
                                                    {this.props.translate.i18n.MODULES.STATIC_PAGES.STATIC_PAGES_IS_FOR_SHOPS}
                                                </InputLabel>
                                                <Select
                                                    value={this.state.is_for_shops}
                                                    onChange={this.handleSetStaticPagesForShops}
                                                    inputProps={{
                                                        name: "select-shop",
                                                        id: "select-shop",
                                                    }}
                                                    // displayEmpty
                                                >
                                                    <MenuItem value={true}>{this.props.translate.i18n.MODULES.STATIC_PAGES.ESHOPS}</MenuItem>
                                                    <MenuItem value={false}>{this.props.translate.i18n.MODULES.STATIC_PAGES.B2B}</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <FormControl className="select-type-widget" style={{marginTop: "5px"}}>
                                                <InputLabel
                                                    htmlFor="select-widget"
                                                    className={"label-select-type"}
                                                    // shrink={true}
                                                >
                                                    {this.props.translate.i18n.MODULES.STATIC_PAGES.STATIC_PAGES_SHOW_IN_WIDGET}
                                                </InputLabel>
                                                <Select
                                                    value={this.state.show_in_widget}
                                                    onChange={this.handleSetStaticPagesInWidget}
                                                    inputProps={{
                                                        name: "select-widget",
                                                        id: "select-widget",
                                                    }}
                                                    // displayEmpty
                                                >
                                                    <MenuItem value={true}>{this.props.translate.i18n.GLOBAL.YES}</MenuItem>
                                                    <MenuItem value={false}>{this.props.translate.i18n.GLOBAL.NO}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Paper style={{padding: "20px"}}>
                                            <Dropzone
                                                onDrop={files => this.handleDrop(files)}
                                                multiple={false}
                                                accept={EXTENSIONS}
                                                >
                                                {({getRootProps, getInputProps, open}) => (
                                                    <div {...getRootProps()} className={`dropzone ${this.state.file !== null ? "dropped":""}`}>
                                                    <input {...getInputProps()} />
                                                        {this.state.file !== null && this.state.file.name?
                                                            <p>{this.state.file.name}</p>
                                                            :
                                                            <p>{this.props.translate.i18n.MODULES.CLIENTS.IMPORT_PLACE}</p>
                                                        }
                                                    </div>
                                                )}
                                            </Dropzone>
                                            <div className={'listDocs'}>
                                                <p className={"titleDocuments"}>{this.props.translate.i18n.MODULES.STATIC_PAGES.DOCUMENTS}</p>
                                                    <ul>
                                                    {this.props.match.params.id && files.length > 0 && files !== undefined && files !== null && files.map((file, index) => {
                                                        return (
                                                            <li key={index} className={'deleteDoc'}>
                                                                <span><a href={file.download} target="_blank">{file.filename}</a></span>
                                                                <div className={'delete'} onClick={() => this.handleDeleteFile(file, index)}>
                                                                    <Icon path={mdiDelete} size={1} />
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                                    {this.state.file.length > 0 ?
                                                        this.state.file.map((f, index) => {
                                                            return (
                                                                <li key={index} className={'deleteDoc'}>
                                                                    <span><a href='javascript:void(0)' target="_blank">{f.name}</a></span>
                                                                    <div className={'delete'} onClick={() => this.handleDeleteFileFromState(f, index)}>
                                                                        <Icon path={mdiDelete} size={1} />
                                                                    </div>
                                                                </li>
                                                            )
                                                        })
                                                        :
                                                        null
                                                    }
                                                    </ul>
                                                    {(files === undefined || files.length === 0) && this.state.file.length === 0 ?
                                                        <p className={'noDocumentsUploaded'}>{this.props.translate.i18n.MODULES.STATIC_PAGES.NOT_DOCUMENTS}</p>
                                                        :
                                                        null
                                                    }
                                            </div>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6} md={7}>
                                <Paper style={{padding: "20px"}}>
                                    <div className={'saveBtn'}>
                                        <CustomButton
                                            progressBar={this.state.loadingBtn}
                                            onClick={this.newOrEditStaticPage}
                                            mystyle={'btn-orange-bg height-36'}
                                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                            justText
                                        >
                                        </CustomButton>
                                    </div>
                                    <ReactQuill
                                        className={'template-text-editor'}
                                        theme="snow"
                                        onChange={this.handleChange}
                                        value={this.state.editorHtml}
                                        modules={this.modules}
                                        formats={this.formats}
                                        bounds={'.app'}
                                        placeholder={''}
                                    />
                                </Paper>
                            </Grid>
                        </Grid>
                    </MuiThemeProvider>
                </div>
                
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/static_pages/createEdit/index.js